module.exports = __webpack_public_path__ + "img/IMG_9543_L_WoodMatted_MockedUp.20aaade5.jpg";